export function settingNameEdit(newName, callback) {
	return {
    type: 'SETTING_NAME_EDIT',
		payload: {
			newName: newName,
		},
		callback: callback,
	}
}

export function settingBirthdayEdit(newBirthday, callback) {
	return {
    type: 'SETTING_BIRTHDAY_EDIT',
		payload: {
			newBirthday: newBirthday,
		},
		callback: callback,
	}
}

export function settingChargeAutomaticEdit(chargeAutomatic) {
	return {
    type: 'SETTING_CHARGE_AUTOMATIC_EDIT',
		payload: {
			chargeAutomatic: chargeAutomatic,
		},
	}
}

export function settingLoginIdEdit(newLoginId, callback) {
	return {
    type: 'SETTING_LOGIN_ID_EDIT',
		payload: {
			newLoginId: newLoginId,
		},
		callback: callback,
	}
}

export function settingLoginPassEdit(newLoginPass, callback) {
	return {
    type: 'SETTING_LOGIN_PASS_EDIT',
		payload: {
			newLoginPass: newLoginPass,
		},
		callback: callback,
	}
}

export function settingEmailEditTokenGet(newEmail, callback) {
	return {
    type: 'SETTING_EMAIL_EDIT_TOKEN_GET',
		payload: {
			newEmail: newEmail,
		},
		callback: callback
	}
}

export function settingEmailEditSubmit(newEmail, token, callback) {
	return {
    type: 'SETTING_EMAIL_EDIT_SUBMIT',
		payload: {
			newEmail: newEmail,
			token: token,
		},
		callback: callback
	}
}

export function settingEmailNotificationMailEdit(value) {
	return {
    type: 'SETTING_EMAIL_NOTIFICATION_MAIL_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingEmailNotificationFavoriteEdit(value) {
	return {
    type: 'SETTING_EMAIL_NOTIFICATION_FAVORITE_EDIT',
		payload: {
			value: value,
		},
	}
}


export function settingEmailNotificationMemberEdit(value) {
	return {
    type: 'SETTING_EMAIL_NOTIFICATION_MEMBER_EDIT',
		payload: {
			value: value,
		},
	}
}


export function settingWebpushAdd(endpoint, publicKey, authToken, callback) {
	return {
    type: 'SETTING_WEBPUSH_ADD',
		payload: {
			endpoint: endpoint,
			publicKey: publicKey,
			authToken: authToken,
		},
		callback: callback,
	}
}

export function settingWebpushDel(webpushDelId, callback) {
	return {
    type: 'SETTING_WEBPUSH_DEL',
		payload: {
			webpushDelId: webpushDelId,
		},
		callback: callback,
	}
}


export function settingWebpushNotificationMailEdit(value) {
	return {
    type: 'SETTING_WEBPUSH_NOTIFICATION_MAIL_EDIT',
		payload: {
			value: value,
		},
	}
}


export function settingWebpushNotificationFavoriteEdit(value) {
	return {
    type: 'SETTING_WEBPUSH_NOTIFICATION_FAVORITE_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingTwoFactorAuthTokenGet(callback) {
	return {
    type: 'SETTING_TWO_FACTOR_AUTH_TOKEN_GET',
		callback: callback,
	}
};

export function settingTwoFactorAuthEdit(type, token, callback) {
	return {
    type: 'SETTING_TWO_FACTOR_AUTH_EDIT',
		payload: {
			type: type,
			token: token,
		},
		callback: callback,
	}
};




export function settingIntroductionEdit(value) {
	return {
    type: 'SETTING_INSTRODUCTION_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingFilterEdit(type, value) {
	return {
    type: 'SETTING_FILTER_EDIT',
		payload: {
			type: type,
			value: value,
		},
	}
}

export function settingRefusalDel(delList, callback) {
	return {
    type: 'SETTING_REFUSAL_DEL',
		payload: {
			delList: delList,
		},
		callback: callback,
	}
}

export function settingNondisplayDel(delList, callback) {
	return {
    type: 'SETTING_NONDISPLAY_DEL',
		payload: {
			delList: delList,
		},
		callback: callback,
	}
}

export function settingSearchPublishEdit(value) {
	return {
    type: 'SETTING_SEARCH_PUBLISH_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingTimelineEdit(value) {
	return {
    type: 'SETTING_TIMELINE_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingStopEdit(value) {
	return {
    type: 'SETTING_STOP_EDIT',
		payload: {
			value: value,
		},
	}
}

export function settingOutage(experience) {
	return {
    type: 'SETTING_OUTAGE',
		payload: {
			experience: experience,
		},
	}
}
